import React from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';

const TestResultsGuide: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="p-4">
        <div className="card bg-white rounded-sm p-4 border border-slate-300">
          <h2 className="text-lg font-bold text-slate-800 mb-4">پک راهنمای دریافت تصویر جواب آزمایش</h2>
          <p className="text-slate-600 mb-4">
            در این بخش راهنمای کامل دریافت تصویر جواب آزمایش را مشاهده می‌کنید.
          </p>
          
          <div className="mb-4">
            <h3 className="text-md font-semibold text-slate-700 mb-2">مراحل دریافت تصویر جواب آزمایش</h3>
            <ol className="list-decimal list-inside text-slate-600 space-y-2">
              <li>وارد صفحه "آزمایش‌های من" شوید</li>
              <li>آزمایش مورد نظر را از لیست پیدا کنید</li>
              <li>روی گزینه "مشاهده جواب" کلیک کنید</li>
              <li>تصویر جواب آزمایش را مشاهده کنید</li>
              <li>در صورت نیاز، روی گزینه "دانلود" کلیک کنید</li>
              <li>فایل را در دستگاه خود ذخیره کنید</li>
            </ol>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default TestResultsGuide;
